import { render, staticRenderFns } from "./candidate-answer-section-module.vue?vue&type=template&id=5a08aaa2&scoped=true"
import script from "./candidate-answer-section-module.vue?vue&type=script&lang=ts"
export * from "./candidate-answer-section-module.vue?vue&type=script&lang=ts"
import style0 from "./candidate-answer-section-module.vue?vue&type=style&index=0&id=5a08aaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08aaa2",
  null
  
)

export default component.exports